import React from 'react';
import { Grid } from '@mui/material';
import { TextField } from '../../../../../components';
import { type ResearchExperienceFieldProps } from './types';

export const ResearchExperienceField: React.FunctionComponent<
  ResearchExperienceFieldProps
> = (props: ResearchExperienceFieldProps) => {
  const { label, fieldData } = props;
  return (
    <Grid size={12}>
      <h4
        style={{
          color: '#224295',
          marginBottom: '0.5rem',
        }}
      >
        {label}
      </h4>
      <TextField
        value={fieldData}
        multiline
        fullWidth
        minRows={4}
        variant="outlined"
        disabled
      />
    </Grid>
  );
};
